import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { parseAction } from "../../../actions/REST";
import config from "../../../config";
import TimePicker from "rc-time-picker";
import Notify from "../../Common/Notify";
import { getUserSchedule, setUserSchedule, getTimeZone } from "../../../actions/ProfileAction";
import "./ProfileSetting.css";
import Spinner from "../../Common/Spinner";

const $ = window.$;

function UserScheduleModal({
  isOpen = false,
  modalClose = () => {},
  handleUserUpdateSchedule = () => {},
}) {
  const dispatch = useDispatch();

  const { userSchedule } = useSelector(mySelector, shallowEqual);

  const modalId = "#user_scheduled_modal";
  const today = moment().date();
  const [isLoading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [disableHour, setDisableHours] = useState([]);
  // const [timeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [allSched, setAllSched] = useState(true);
  const [zone, setTimeZone] = useState();
  const [timeZoneArr, setTimeZoneArr] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [currentTZ, setCurrentTZ] = useState("");

  const daysOfWeek = [
    { value: 1, label: "MON" },
    { value: 2, label: "TUE" },
    { value: 3, label: "WED" },
    { value: 4, label: "THU" },
    { value: 5, label: "FRI" },
    { value: 6, label: "SAT" },
    { value: 0, label: "SUN" },
  ];

  useEffect(() => {
    setLoading(true);
    dispatch(getTimeZone())
      .then((res) => {
        const currentTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setCurrentTZ(currentTZ);
        setTimeZoneArr(res.result.time_zone);
      });
    dispatch(getUserSchedule())
      .then((res) => {
        const copy = times;
        if (res.result.schedules.length > 0) {
          res.result.schedules.forEach((item, index) => {
            // const date = moment().startOf("week").add(1, "day").add(index, "day");
            const parseDateOrTime = (value) => {
              if (!value) return null;

              if (moment(value, moment.ISO_8601, true).isValid()) {
                return moment(value);
              }
              if (moment(value, "HH:mm", true).isValid()) {
                return moment(value, "HH:mm");
              }
              if (moment(value, "hh:mm A", true).isValid()) {
                return moment(value, "hh:mm A");
              }
              return null;
            };

            copy[item.day] = {
              day: item.day,
              check_in: parseDateOrTime(item.check_in),
              check_out: parseDateOrTime(item.check_out),
              time_zone: item.time_zone || timeZoneArr[0],
              status: true,
              check_in_state: true,
              check_out_state: true,
              // date: date.format("DD"),
            };
          });
          setTimeZone(res.result.schedules[0].time_zone);
          setTimes(copy);
        }
        if (res.result.schedules.length === 7) {
          setAllSched(true);
        }
        setLoading(false);
      });
  }, []);

  const [times, setTimes] = useState(
    daysOfWeek.reduce((acc, day, index) => {
      // const date = moment().startOf("week").add(1, "day").add(index, "day");

      acc[day.value] = {
        day: day.value,
        check_in: moment().set({ hour: 8, minute: 0, second: 0, millisecond: 0 }),
        check_out: moment().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }),
        time_zone: zone || "",
        check_in_state: false,
        check_out_state: false,
        // date: date.format("DD"),
      };
      return acc;
    }, {})
  );

  const handleTimeChange = (dayValue, type, time) => {
    if (type === "check_in") {
      setTimes(prev => ({
        ...prev,
        [dayValue]: {
          ...prev[dayValue],
          check_in: time,
          check_in_state: true,
          status: true,
        }
      }));

      // Disable same hours in check_out
      const hour = parseInt(time.format("HH"), 10)
      const arr = Array.from({ length: hour + 1 }, (_, i) => i);
      setDisableHours(prev => {
        const copy = [...prev];
        copy[dayValue] = arr;
        return copy;
      });

    } else {
      setTimes(prev => ({
        ...prev,
        [dayValue]: {
          ...prev[dayValue],
          [type]: time,
          check_out_state: true,
          status: true,
        }
      }));
    }
  };

  useEffect(() => {
    if (!allSched) {
      // handleSetUserSchedule();
    }
  }, [allSched]);

  // fixed false
  const handleSetAllSched = (state) => {
    if (state) {
      setTimes(prev => {
        const updated = {};
        for (const key in prev) { 
          updated[key] = { ...prev[key], state: true };
        }
        return updated;
      });
      setAllSched(state);
      setOpenConfirm(false);

    } else {
      setTimes(prev => {
        const updated = {};
        for (const key in prev) {
          updated[key] = {
            ...prev[key],
            status: false,
            check_in: moment().set({ hour: 8, minute: 0, second: 0, millisecond: 0 }),
            check_out: moment().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }),
            check_in_state: false,
            check_out_state: false,
          };
        }
        return updated;
      });
      setAllSched(state);
      setOpenConfirm(false);
      setShowWarning(false);
    }
  }

  // fixed false
  const handleTimeStatus = (status, dayValue, index) => {
    if (status) {
      setTimes(prev => ({
        ...prev,
        [dayValue]: {
          ...prev[dayValue],
          status: true,
          time_zone: zone || "",
        }
      }));
    } else {
      let copy = times;
      copy = {
        ...copy,
        [dayValue]: {
          ...copy[dayValue],
          check_in: moment().set({ hour: 8, minute: 0, second: 0, millisecond: 0 }),
          check_out: moment().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }),
          check_in_state: false,
          check_out_state: false,
          status: false,
          time_zone: zone || "",
        }
      }
      setTimes(copy);
      // handleSetUserSchedule(copy);
    }
  }

  const handleSetUserSchedule = (newSched) => {
    setLoading(true);
    let warning = false;
    Object.keys(times).forEach((key) => {
      if (times[key].check_in_state !== times[key].check_out_state) {
        warning = true;
      }
    });

    if (!warning) {
      const activeSched = Object.values(times)
        .filter(item => item.status === true)
        .map(item => ({
          ...item,
          check_in: moment(item.check_in).format("HH:mm"),
          check_out: moment(item.check_out).format("HH:mm"),
          // time_zone: timeZoneArr[0],
          time_zone: currentTZ,
        }));

      dispatch(setUserSchedule(activeSched))
        .then((res) => {
          setLoading(false);
          setShowWarning(false);
          handleUserUpdateSchedule(activeSched);
          Notify.info("Successfully updated schedule.");
          parseAction(
            "post",
            config.BASE_URL + "/parse/functions/updateAvailability",
            {
              isAvailable: true,
              useSchedule: true,
            }, { "Content-Type": "application/json",}
          );
        });

    } else {
      setLoading(false);
      setShowWarning(true);
    }
  }

  useEffect(() => {
    if (isOpen) {
      $(modalId).modal({
        backdrop: "static",
        keyboard: false
      });
      $(modalId).css({
        "z-index": "3000",
        "position": "fixed"
      });
      $(modalId).modal("show");
    } else {
      $(modalId).modal("hide");
    }

    return () => {
      $(modalId).modal("hide");
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open").css("padding-right", "");
    };
  }, [isOpen, modalId]);

  const handleSetTimeZone = (zone) => {
    setTimeZone(zone);
    setTimes(prev => {
      const updated = {};
      for (const key in prev) {
        updated[key] = {
          ...prev[key],
          time_zone: zone
        };
      }
      return updated;
    });
  }

  return (
    <div id="user_scheduled_modal" className="user-schedule-modal-container">
      <div className="user-schedule-container">
        <div className="save-changes-flex" style={{ marginLeft: 5 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span
                className="d-none d-md-inline user-schedule-header"
                // style={{ fontWeight: "700", fontSize: "20px", marginLeft: "5px" }}
              >
                SET YOUR WEEKLY HOURS
              </span>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => modalClose()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div className="schedule-selection">
          <span></span>
          <span className="schedule-header">Clock In</span>
          <span></span>
          <span className="schedule-header">Clock Out</span>
          <span>
            {/* <button 
              type="button" 
              className="btn btn-hubchart btn-hubchart-close sched-action"
              onClick={() => handleSetAllSched(!allSched)}
            >
              {allSched
                ? <i className="fas fa-times"></i>
                : <i className="fas fa-check text-success"></i>
              }
            </button> */}
          </span>
          {daysOfWeek.map((day, index) => (
            <React.Fragment key={day.value}>
              <span className="schedule-header" style={{ textAlign: "left" }}>
                {day.label}
              </span>
              <div className="">
                <div 
                  className="card-timePicker no-shadow user-schedule-timepicker"
                  style={{
                    backgroundColor: !times[day.value].check_in_state ? "#f7f7f7" : "",
                    border: times[day.value].check_in_state !== times[day.value].check_out_state 
                      && times[day.value].check_in_state === false
                      && showWarning 
                      ? "1px solid red" : "",
                  }}
                >
                  <TimePicker
                    className={`${!times[day.value].check_in_state ? "fake-disabled" : ""}`}
                    showSecond={false}
                    use12Hours={true}
                    format="h:mm A"
                    value={times[day.value].check_in}
                    onChange={(time) => handleTimeChange(day.value, "check_in", time || moment().startOf("hour"))}
                    allowEmpty={false}
                    minuteStep={15}
                    // disabled={isLoading || !times[day.value].state}
                  />
                </div>
                {/* <div className="user-schedule-timepicker-warning">
                  {times[day.value].check_in_state !== times[day.value].check_out_state 
                    && times[day.value].check_in_state === false
                    && showWarning 
                    ? "Required" : ""}
                </div> */}
              </div>
              <div style={{ textAlign: "center" }}> - </div>
              <div className="">
                <div 
                  className="card-timePicker no-shadow user-schedule-timepicker"
                  style={{
                    backgroundColor: !times[day.value].check_out_state ? "#f7f7f7" : "",
                    border: times[day.value].check_in_state !== times[day.value].check_out_state 
                      && times[day.value].check_out_state === false
                      && showWarning 
                      ? "1px solid red" : "",
                  }}
                >
                  <TimePicker
                    className={`${!times[day.value].check_out_state ? "fake-disabled" : ""}`}
                    showSecond={false}
                    use12Hours={true}
                    format="h:mm A"
                    value={times[day.value].check_out}
                    onChange={(time) => handleTimeChange(day.value, "check_out", time || moment().startOf("hour"))}
                    allowEmpty={false}
                    minuteStep={15}
                    // disabled={isLoading || !times[day.value].state}
                    // disabledHours={() => disableHour[day.value]}
                  />
                </div>
                {/* <div className="user-schedule-timepicker-warning">
                  {times[day.value].check_in_state !== times[day.value].check_out_state 
                    && times[day.value].check_out_state === false
                    && showWarning 
                    ? "Required" : ""}
                </div> */}
              </div>
              <div>
                {(times[day.value].check_in_state || times[day.value].check_out_state) &&
                  <a
                    href="#"
                    className="sched-remove-action"
                    onClick={() => handleTimeStatus(false, day.value, index)}
                  >
                    <i className="fa fa-trash-o"></i>
                  </a>
                }
              </div>
            </React.Fragment>
          ))}
          {/* <span className="schedule-header" style={{ textAlign: "left" }}>
            TIME ZONE
          </span>
          <div className="form-group time-zone-select">
            <div className="card">
              <Select 
                className="form-control"
                style={{ color: "##495057 !important" }} 
                value={zone}
                onChange={(e) => handleSetTimeZone(e.target.value)}
                disabled={isLoading}
              >
                {timeZoneArr.map((day, index) => (
                  <option key={index} value={day}>
                    {day}
                  </option>
                ))}
              </Select>
              <i className="fas fa-map-marker hc-primary-text"></i>
            </div>
          </div> */}
          <div className="user-schedule-timepicker-warning bottom-warning">
            {showWarning ? "Enter both clock in and out times before saving" : ""}
          </div>
        </div>
        <div className="schedule-footer">
          <a
            className="user-status-options"
            onClick={() => handleSetAllSched(false)}
          >
            Clear all
          </a>
          <div className="ml-auto">
            <button
              type="button"
              className="btn-hubchart btn-hubchart-close btn-sm schedule-action-cancel"
              style={{ marginRight: "10px" }}
              onClick={() => modalClose()}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn-sm btn-hubchart btn-hubchart-primary schedule-reason-save"
              onClick={() => handleSetUserSchedule()}
            >
              Save
            </button>
          </div>
          
        </div>
        {isLoading && (
          <CustomLoader
            isLoading={isLoading}
          />
        )}
        {openConfirm && (
          <Confirmation
            handleSetAllSched={() => handleSetAllSched(allSched)}
            onClose={setOpenConfirm}
            allSched={allSched}
          />
        )}
      </div>
    </div>
  );
}

const CustomLoader = ({ isLoading }) => {
  return (
    <div
      className="loader"
      style={{
        display: isLoading ? "inline-grid" : "none",
        position: "absolute",
        borderRadius: "20px",
        overflow: "hidden",
        backgroundColor: "#ccccccc2",
      }}
    >
      <div align="center">
        <div className="loader-container">
          <div>
            <div className="loader-message">
              <span>Please wait...</span>
              <Spinner size={5} color={"#fbba09"} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Confirmation = ({ handleSetAllSched, onClose = () => {}, allSched }) => {
  return (
    <div className="assignment-notify-container">
      <div className="attention-notify-box" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6 style={{ width: "220px" }}>
            { allSched ? "Enable all" : "Remove all current" } scheduled ?
          </h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className={`btn ${ allSched ? "btn-primary" : "btn-danger" }`}
              onClick={() => handleSetAllSched()}
            >
              { allSched ? "Enable" : "Remove" }
            </button>
            <button 
              type="button btn-sm" 
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mySelector = (state) => ({
  userSchedule: state.profile.userSchedule,
});

export default UserScheduleModal;
